import React from 'react';
import Loadable from 'react-loadable';
import Loading from 'components/Loading';

export default Loadable({
  loader: () => import('./index'),
  loading: () => <Loading visible />,
});

export const LoginMethodsForm = Loadable({
  loader: () => import('./containers/LoginMethodsFormPage'),
  loading: () => <Loading visible />,
});

export const LoginMethodsList = Loadable({
  loader: () => import('./containers/LoginMethodsListPage'),
  loading: () => <Loading visible />,
});
